import React, { useState, useRef, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { TbTrashX } from "react-icons/tb";
import { BiCloudUpload } from "react-icons/bi";
import { useFormik } from "formik";
import * as Yup from "yup";
import { handleApi } from "../../../utils/authentication";
import { toast } from "react-toastify";
import { UPDATE_USER_DATA } from "../../../redux/features/user/userSlice";
import user_placeholder from "../../../assests/user_default.png";
import Select from "react-select";
import { customStyles } from "../../../utils/select_style";
import { useLocation } from "react-router-dom";
import { getUserRoleList } from "../../../services/ApiService";
import { EditProfileImage } from "../../../components/superadmin";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";

const EditAdminProfile = () => {
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const profileImageRef = useRef(null);
  const user = useSelector((state) => state?.user);
  const [imageUri, setImageUri] = useState("");
  const [show, setShow] = useState(false);
  const [file, setFile] = useState("");
  const [userRoles, setUserRoles] = useState([]);
  const dispatch = useDispatch();
  const [showOldPassword,setShowOldPassword]=useState(false)
  const [showNewPassword,setShowNewPassword]=useState(false)
  const [showConfirmPassword,setShowConfirmPassword]=useState(false)

  let roles = [
    { value: 1, label: "Admin" },
    // {value:2,label:"Owner"},
    { value: 3, label: "Member" },
    // {value:4,label:"Viewer"}
  ];

  const location = useLocation();
  const fetchUserRoles = async () => {
    try {
      let result = await getUserRoleList();
      if (result?.success) {
        setUserRoles(result?.data?.roles);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleEditProfile = async () => {
    try {
      setLoading(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();

      formData.append("user_id", user?.user_id);
      formData.append("email", formik_profile?.values?.email);
      formData.append("first_name", formik_profile?.values?.first_name);
      formData.append("last_name", formik_profile?.values?.last_name);

      if (
        userRoles["Admin"] === user?.role_id &&
        userRoles["Admin"] < formik_profile.values.role?.value
      ) {
        toast.error("Role Seleted Invalid");
        return;
      }
      formData.append("role_id", formik_profile.values.role?.value);

      if (formik_profile?.values?.phone_number != "") {
        formData.append("phone_number", formik_profile?.values?.phone_number);
      }
      if (formik_profile?.values?.bio != "") {
        formData.append("bio", formik_profile?.values?.bio);
      }
      if (formik_profile?.values?.job_name != "") {
        formData.append("job_name", formik_profile?.values?.job_name);
      }
      if (formik_profile?.values?.country_name != "") {
        formData.append("country_name", formik_profile?.values?.country_name);
      }
      if (formik_profile?.values?.city_state_name != "") {
        formData.append(
          "city_state_name",
          formik_profile?.values?.city_state_name
        );
      }
      if (formik_profile?.values?.postal_code != "") {
        formData.append("postal_code", formik_profile?.values?.postal_code);
      }

      if (imageUri && file) {
        let response = await fetch(imageUri);
      
        let image_file = await response?.blob();
        formData.append("profile_image", image_file, file?.name);
      }

      let result = await handleApi(
        "handle_edit_user",
        method,
        headers,
        formData
      );
      if (result?.success) {
        toast.success(
          result?.data?.message
            ? result?.data?.message
            : "User details updated successfully");
        dispatch(
          UPDATE_USER_DATA({
            first_name: result?.data?.user_info?.first_name,
            last_name: result?.data?.user_info?.last_name,
            profile_image: result?.data?.user_info?.profile_image,
            phone_number: result?.data?.user_info?.phone_number,
            bio: result?.data?.user_info?.bio,
            job_name: result?.data?.user_info?.job_name,
            country_name: result?.data?.user_info?.country_name,
            city_state_name: result?.data?.user_info?.city_state_name,
            postal_code: result?.data?.user_info?.postal_code,
            role_id: result?.data?.user_info?.role_id,
            role_name: result?.data?.user_info?.role_name,
          })
        );
        setImageUri(result?.data?.user_info?.profile_image);
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to update user details");
      }
    } catch (e) {
      toast.error(e?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    try {
      setLoading1(true);
      let method = "POST";
      let headers = {};
      let formData = new FormData();
      formData.append("user_id", user?.user_id);

      formData.append("old_password", formik?.values?.old_password);
      formData.append("new_password", formik?.values?.new_password);
      let result = await handleApi(
        "handle_reset_password",
        method,
        headers,
        formData
      );
      if (result?.success) {
        toast.success(
          result?.data?.message
            ? result?.data?.message
            : "Password updated successfully");
      } else {
        toast.error(
          result?.error?.error_message
            ? result?.error?.error_message
            : "Failed to update user password");
      }
    } catch (e) {
      console.log(e);
      toast.error(e?.message);
    } finally {
      setLoading1(false);
    }
  };

  const validationSchema = Yup.object({
    old_password: Yup.string().required("Old Password is required"),
    new_password: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .max(16, "Password must be 16 characters or less")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/,
        "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
      )
      .required(" Password is required"),

    confirm_password: Yup.string()
      .oneOf([Yup.ref("new_password"), null], "Password does not match")
      .when("new_password", (new_password, schema) =>
        new_password ? schema.required("Confirm Password is required") : schema
      ),
  });

  const formik = useFormik({
    initialValues: {
      old_password: "",
      new_password: "",
      confirm_password: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleResetPassword();
    },
  });

  const validationSchema_profile = Yup.object({
    first_name: Yup.string().required("First Name is required").matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
    last_name: Yup.string().required("Last Name is required").matches(/^[A-Za-z]+$/, 'Only letters are allowed'),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    role: Yup.object().required("Role is Required"),
    phone_number: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be exactly 10 digits"),
    country_name: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed"),
    city_state_name: Yup.string()
    .matches(/^[A-Za-z\s]+$/, "Only letters and spaces are allowed"),
 
    bio: Yup.string().max(500, 'Bio must be less than 200 characters'),
    job_name: Yup.string().max(50, 'Job name must be less than 50 characters'),
  });

  const formik_profile = useFormik({
    initialValues: {
      first_name: user?.first_name,
      last_name: user?.last_name,
      email: user?.email,
      phone_number: user?.phone_number ? user?.phone_number : "",
      bio: user?.bio ? user?.bio : "",
      job_name: user?.job_name ? user?.job_name : "",
      country_name: user?.country_name ? user?.country_name : "",
      city_state_name: user?.city_state_name ? user?.city_state_name : "",
      postal_code: user?.postal_code ? user?.postal_code : "",
      role: { label: user?.role_name, value: user?.role_id },
    },
    validationSchema: validationSchema_profile,
    onSubmit: (values) => {
      handleEditProfile();
    },
  });

  const handleDeleteImage = () => {
    if (imageUri) {
      setImageUri("");
    }
  };
  //reads the image and opens the modal by setting setShow-> true
  const handleImageUpload = (event) => {
    const file = event.target.files[0];

    if (file) {

      if (!file.type.startsWith("image/")) {
        toast.error("Only image files are allowed!");
        event.target.value = ""; // clear invalid file
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setImageUri(reader.result);
        setShow(true); // Set the image URI in state
      };
      reader.readAsDataURL(file); // Read the file as a data URL
      setFile(file);
    }
    event.target.value = "";
  };
  useEffect(() => {
    setImageUri(user?.profile_image);
    fetchUserRoles();
  }, []);

  return (
    <div className="">
      {location.pathname.includes("client/settings/user_profile") && (
        <form
          className="d-flex flex-column gap_lg"
          onSubmit={formik_profile.handleSubmit}
        >
          <div className="card profile_card ">
            <EditProfileImage
              show={show}
              setShow={setShow}
              uri={imageUri}
              setImageUri={setImageUri}
              aspect_ratio={1}
            />
            <div>
              <h5 className="pb-0">Main Info</h5>
            </div>
            {/* edit profile image */}

            <div className="row border-1 border-bottom pb-4">
              <div className="col-xl-2 d-flex justify-content-center justify-content-xl-start  ">
                {imageUri ? (
                  <img
                    src={imageUri ? imageUri : user_placeholder}
                    alt="Profile"
                  />
                ) : (
                  <img
                    src={user_placeholder}
                    style={{ borderRadius: "0%" }}
                    alt="Profile"
                  />
                )}
                <input
                  ref={profileImageRef}
                  type="file"
                  id="profile_image"
                  className="d-none"
                  accept="image/*"
                  onChange={handleImageUpload}
                />
              </div>
              <div className=" col-xl-6 row d-flex align-items-end  ">
                <div className="col-12 col-md-12 col-lg-6 mb-2">
                  <button
                    type="button"
                    disabled={imageUri ? false : true}
                    className={`w-100 ${
                      !imageUri && "disable_btn"
                    } btn btn-outline-custom btn-outline-primary  rounded-pill d-flex  justify-content-center align-items-center gap-1`}
                    onClick={handleDeleteImage}
                  >
                    <TbTrashX /> Delete Image
                  </button>
                </div>
                <div className="col-12 col-md-12 col-lg-6  mb-2 ">
                  <button
                    type="button"
                    onClick={() => {
                      profileImageRef.current.click();
                    }}
                    className="w-100 py-2 gap-1 btn btn-primary rounded-pill d-flex   justify-content-center  align-items-center  "
                  >
                    {" "}
                    <BiCloudUpload />  Upload Profile Image
                  </button>
                </div>
              </div>
            </div>

            <div className="mb-1 row">
              <label htmlFor="first_name" className="col-lg-2  col-form-label">
                Firstname*
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  id="first_name"
                  placeholder="Firstname"
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.first_name}
                />
                {formik_profile.touched.first_name &&
                formik_profile.errors.first_name ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.first_name}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="last_name" className="col-lg-2  col-form-label">
                Lastname*
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  id="last_name"
                  placeholder="Lastname"
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.last_name}
                />
                {formik_profile.touched.last_name &&
                formik_profile.errors.last_name ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.last_name}
                  </div>
                ) : null}
              </div>
            </div>

            {/* <div className="mb-1 row mt-2">
            <div className='col-lg-8 d-flex justify-content-end'>
              {!loading ?
                <button type='submit' className='btn btn-primary rounded-pill px-5'>Update</button> :
                <button type='button' className='btn btn-primary rounded-pill px-5' disabled>processing...</button>}

            </div>
          </div> */}
          </div>

          {/* personal info */}
          <div className="card profile_card">
            <div>
              <h5 className="pb-0">Personal Info</h5>
            </div>
            <div className="mb-1 row">
              <label htmlFor="email" className="col-lg-2  col-form-label">
                Email*
              </label>
              <div className="col-lg-6">
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Email"
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.email}
                  disabled
                />
                {formik_profile.touched.email && formik_profile.errors.email ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.email}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label
                htmlFor="phone_number"
                className="col-lg-2  col-form-label"
              >
                Phone
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  id="phone_number"
                  placeholder="ex:8987678905"
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.phone_number}
                  maxLength={12}
                />
                {formik_profile.touched.phone_number &&
                formik_profile.errors.phone_number ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.phone_number}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="bio" className="col-lg-2  col-form-label">
                Bio
              </label>
              <div className="col-lg-6">
                <textarea
                  type="textarea"
                  className="form-control"
                  id="bio"
                  placeholder=""
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.bio}
                  rows={3}
                />
                {formik_profile.touched.bio && formik_profile.errors.bio ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.bio}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="job_name" className="col-lg-2  col-form-label">
                Job
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  id="job_name"
                  placeholder="ex:Team Manager"
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.job_name}
                />
                {formik_profile.touched.job_name &&
                formik_profile.errors.job_name ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.job_name}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="role" className="col-lg-2 col-form-label">
                Role*{" "}
              </label>
              <div className="col-lg-6">
                <Select
                  id="role"
                  name="role"
                  placeholder="Select Role"
                  styles={customStyles}
                  value={formik_profile.values.role}
                  options={roles}
                  onChange={(selected_options) => {
                    formik_profile.setFieldValue("role", selected_options);
                  }}
                  isDisabled={
                    user?.role_id >
                    (userRoles["Admin"] ? userRoles["Admin"] : 2)
                      ? true
                      : false
                  }
                />
                {formik_profile.touched.role && formik_profile.errors.role ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.role}
                  </div>
                ) : null}
              </div>
            </div>

            {/* <div className="mb-1 row mt-2">
            <div className='col-lg-8 d-flex justify-content-end'>
              {!loading ?
                <button type='submit' className='btn btn-primary rounded-pill px-5'>Update</button> :
                <button type='button' className='btn btn-primary rounded-pill px-5' disabled>processing...</button>}

            </div>
          </div> */}
          </div>
          {/* address info */}
          <div className="card profile_card ">
            <div>
              <h5 className="pb-0">Address Info</h5>
            </div>
            <div className="mb-1 row">
              <label
                htmlFor="country_name"
                className="col-lg-2  col-form-label"
              >
                Country
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  id="country_name"
                  placeholder="Country"
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.country_name}
                />
                {formik_profile.touched.country_name &&
                formik_profile.errors.country_name ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.country_name}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label
                htmlFor="city_state_name"
                className="col-lg-2  col-form-label"
              >
                City/State
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  id="city_state_name"
                  placeholder="City/State"
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.city_state_name}
                />
                {formik_profile.touched.city_state_name &&
                formik_profile.errors.city_state_name ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.city_state_name}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row">
              <label htmlFor="postal_code" className="col-lg-2  col-form-label">
                Postal Code
              </label>
              <div className="col-lg-6">
                <input
                  type="text"
                  className="form-control"
                  id="postal_code"
                  placeholder="Postal Code"
                  onChange={formik_profile.handleChange}
                  onBlur={formik_profile.handleBlur}
                  value={formik_profile.values.postal_code}
                />
                {formik_profile.touched.postal_code &&
                formik_profile.errors.postal_code ? (
                  <div className="text-danger text-start small">
                    {formik_profile.errors.postal_code}
                  </div>
                ) : null}
              </div>
            </div>
            <div className="mb-1 row mt-2">
              <div className="col-lg-8 d-flex justify-content-end">
                {!loading ? (
                  <button
                    type="submit"
                    className="btn btn-primary rounded-pill px-5"
                  >
                    Update
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-primary rounded-pill px-5"
                    disabled
                  >
                    processing...
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
      )}

      {/* reset password */}
      {location.pathname.includes("client/settings/security") && (
        <form className="card profile_card " onSubmit={formik.handleSubmit}>
          <div>
            <h5 className="pb-0">Reset Password</h5>
          </div>
          <div className="mb-1 row">
            <label htmlFor="old_password" className="col-lg-2  col-form-label">
              Old Password*
            </label>
            <div className="col-lg-6">
              <div className="d-flex justify-content-center align-items-center position-relative">
              <input
                type={showOldPassword ? "text" : "password"}
                className="form-control"
                id="old_password"
                placeholder="Password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.old_password}
              />
              <span
                className=" eye_btn "
                style={{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)"}}
                onClick={() => {
                  setShowOldPassword((prev) => !prev);
                }}
              >
                {!showOldPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
            </div>
              {formik.touched.old_password && formik.errors.old_password ? (
                <div className="text-danger text-start small">
                  {formik.errors.old_password}
                </div>
              ) : null}
            </div>
          </div>
          <div className="mb-1 row">
            <label htmlFor="new_password" className="col-lg-2  col-form-label">
              New Password*
            </label>
            <div className="col-lg-6">
              <div className="d-flex justify-content-center align-items-center position-relative">
              <input
                type={showNewPassword ? "text" : "password"}
                className="form-control"
                id="new_password"
                placeholder="New Password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.new_password}
              />
              <span
                className=" eye_btn "
                style={{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)"}}
                onClick={() => {
                  setShowNewPassword((prev) => !prev);
                }}
              >
                {!showNewPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
              </div>
      
              {formik.touched.new_password && formik.errors.new_password ? (
                <div className="text-danger text-start small">
                  {formik.errors.new_password}
                </div>
              ) : null}
            </div>
          </div>
          <div className="mb-1 row">
            <label
              htmlFor="confirm_password"
              className="col-lg-2  col-form-label"
            >
              Confirm Password*
            </label>
            <div className="col-lg-6">
              <div className="d-flex justify-content-center align-items-center position-relative">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control"
                id="confirm_password"
                placeholder="Confirm Password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirm_password}
              />
              <span
                className=" eye_btn "
                style={{position:"absolute",right:"10px",top:"50%",transform:"translateY(-50%)"}}
                onClick={() => {
                  setShowConfirmPassword((prev) => !prev);
                }}
              >
                {!showConfirmPassword ? <FaRegEyeSlash /> : <FaRegEye />}
              </span>
              </div>
          

              {formik.touched.confirm_password &&
              formik.errors.confirm_password ? (
                <div className="text-danger text-start small">
                  {formik.errors.confirm_password}
                </div>
              ) : null}
            </div>
          </div>
          <div className="mb-1 row mt-2">
            <div className="col-lg-8 d-flex justify-content-end">
              {!loading1 ? (
                <button
                  type="submit"
                  className="btn btn-primary rounded-pill px-5"
                >
                  Update
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary rounded-pill px-5"
                  disabled
                >
                  processing...
                </button>
              )}
            </div>
          </div>
        </form>
      )}
    </div>
  );
};

export default EditAdminProfile;
